import { render, staticRenderFns } from "./RunnitImage.vue?vue&type=template&id=71a1a811&scoped=true"
import script from "./RunnitImage.vue?vue&type=script&lang=ts"
export * from "./RunnitImage.vue?vue&type=script&lang=ts"
import style0 from "./RunnitImage.vue?vue&type=style&index=0&id=71a1a811&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1a811",
  null
  
)

export default component.exports